import { uniqueId } from '@/components/home/Contents'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

function ContactUsBanner() {
  return (
    <>
      <section className={`with-banner bg-white-ice-three hidden xl:block`}>
        <div className='main-banner'>
          <div className='container mx-auto pt-16 pb-32'>
            <div className='row sm-mx:flex-col-reverse'>
              <div className='w-full text-center'>
                <LazyMotion features={domAnimation}>
                  <m.div
                    key={uniqueId('animation-')}
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    initial={{ scale: 0.8, y: 100, opacity: 0 }}
                  >
                    <div className='banner-content text-center'>
                      <h2 className='text-4xl2 md-mx:text-4xl font-bold text-secondary mb-4'>
                        Searching For Full Customizable Storage and
                        <br /> Shipping Solution?
                      </h2>
                      <h5 className='text-2xl font-normal text-gray-400 mb-1'>
                        Our Dedicated Storage Expert’s Team Are Waiting To Hear From You!
                      </h5>
                    </div>
                  </m.div>
                </LazyMotion>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContactUsBanner
